import { useEffect } from "react";

const SITE_NAME = "IDCardGen";
const SITE_IMAGE = "https://idcardgen.com/id-card-gen-logo.png";

export default function useSeo({ title, description, canonical, keywords }) {
    useEffect(() => {
        if (title) {
            document.title = title;
        }

        const ensureMeta = (name, content, attr = "name") => {
            if (!content) return;
            let el = document.head.querySelector(`meta[${attr}='${name}']`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, name);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };

        ensureMeta("description", description);
        ensureMeta("keywords", keywords);
        ensureMeta("og:site_name", SITE_NAME, "property");
        ensureMeta("og:type", "website", "property");
        ensureMeta("og:title", title, "property");
        ensureMeta("og:description", description, "property");
        ensureMeta("og:image", SITE_IMAGE, "property");
        if (canonical) ensureMeta("og:url", canonical, "property");
        ensureMeta("twitter:card", "summary_large_image", "name");
        ensureMeta("twitter:title", title, "name");
        ensureMeta("twitter:description", description, "name");
        ensureMeta("twitter:image", SITE_IMAGE, "name");

        if (canonical) {
            let link = document.head.querySelector("link[rel='canonical']");
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
        }
    }, [title, description, canonical, keywords]);
}
